import { SentimentType } from '@granlupo/api-client/generated/content/zeus'
import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import type { BlogPostReviewResult } from '../../data/BlogPostReviewFragment'
import type { ProductReviewResult } from '../../data/ProductReviewFragment'
import SvgThumb from '../../svg/icons/Thumb'
import { useAuth } from '../../user/UserContext'
import style from './ReviewRating.module.sass'

type ReviewRatingItemProps = {
	review: ProductReviewResult | BlogPostReviewResult
	sentimentType: SentimentType
	userVoted: SentimentType | undefined
	incrementPoints: () => void
	openLoginModal: () => void
	extraPoint: number
}

export const ReviewRatingItem: FunctionComponent<ReviewRatingItemProps> = ({
	review,
	sentimentType,
	userVoted,
	incrementPoints,
	openLoginModal,
	extraPoint,
}) => {
	const auth = useAuth()
	const productReactions =
		'productReviewReactions' in review &&
		review.productReviewReactions.filter((reaction) => reaction.sentiment === sentimentType)
	const blogPostReactions =
		'blogPostReviewReactions' in review &&
		review.blogPostReviewReactions.filter((reaction) => reaction.sentiment === sentimentType)

	const isBlocked = auth.status === 'signedIn' && auth.user.blockedAt

	return (
		<>
			<div className={clsx(style.ratingContent, isBlocked && style.notAllowed)}>
				<div className={clsx(style.ratingWrapper, isBlocked && style.pointerEventsNone)}>
					<div className={style.checkboxInput}>
						<label className={style.labelWrapper}>
							<input
								type="checkbox"
								name="points"
								disabled={isBlocked}
								value={sentimentType}
								checked={userVoted === sentimentType}
								className={style.input}
								onChange={auth.status === 'signedIn' ? incrementPoints : openLoginModal}
							/>
							<span
								className={clsx(
									style.label,
									sentimentType === SentimentType.negative && style.labelRed,
									sentimentType === SentimentType.positive && style.labelGreen,
								)}
							>
								<span className={clsx(style.icon, sentimentType === SentimentType.negative && style.iconRotated)}>
									<SvgThumb />
								</span>
								<span className={style.ratingText}>
									{productReactions
										? productReactions.length + extraPoint
										: blogPostReactions && blogPostReactions.length + extraPoint}
								</span>
							</span>
						</label>
					</div>
				</div>
			</div>
		</>
	)
}
